
import { defineComponent } from 'vue';
import { useStore } from 'vuex';

import _ from 'lodash';
import ModalHeader from '@/modules/modals/components/ModalHeader.vue';
import ModalBody from '@/modules/modals/components/ModalBody.vue';
import ModalFooter from '@/modules/modals/components/ModalFooter.vue';
import ModalService from '@/modules/modals/services/modalService';
import Loader from '@/components/Loader.vue';
import CompsManager from '@/manager/2.6/CompsManager';
import LocalStorageManager from '@/manager/LocalStorageManager';
import CompAddressUtils from '@/models/comp/CompAddressUtils';

export default defineComponent({
    components: { ModalHeader, ModalBody, ModalFooter, Loader },
    props: ['activeComp', 'tabIndex'],
    data() {
        return {
            modal: null,
            isLoading: false,
        };
    },
    setup(props) {
        const store = useStore();
        const address1AndUnitNo = CompAddressUtils.combineAddress1AndUnitNo(props.activeComp.address);
        let misMatchAddress = LocalStorageManager.getMisMatchAddress(address1AndUnitNo);

        return {
            store,
            misMatchAddress,
        };
    },
    mounted() {
        const modalElement = this.$refs.prMisMatchAddress;
        this.modal = ModalService.initialize(modalElement, this);
        ModalService.size(modalElement, '');
        ModalService.open(this.modal);
    },
    methods: {
        async useClosestMatch() {
            this.isLoading = true;

            // Update local stroage
            this.updateLocalStorage(true);

            CompsManager.setActiveComp(this.tabIndex);

            (this as any).eventBus.emit('resetGridHeaderElements');

            this.isLoading = false;
            ModalService.hide(this.modal);
        },
        async prContinue() {
            this.isLoading = true;

            // Update local stroage
            this.updateLocalStorage(false);

            CompsManager.setActiveComp(this.tabIndex);

            (this as any).eventBus.emit('resetGridHeaderElements');

            this.isLoading = false;
            ModalService.hide(this.modal);
        },
        updateLocalStorage(usingClosestAddress: boolean) {
            if (this.misMatchAddress) {
                this.misMatchAddress.usingClosestAddress = usingClosestAddress;

                const address1AndUnitNo = CompAddressUtils.combineAddress1AndUnitNo(this.misMatchAddress.compAddress);
                LocalStorageManager.saveMisMatchAddress(address1AndUnitNo, this.misMatchAddress);
            }
        },
    },
});
